import WinlosesTypes from './types';
import { MusicWinlosesState, MusicWinlosesDispatchAction } from './state';
import { Reducer } from 'redux';

const initialState: MusicWinlosesState = {
    wins: '',
    loses: '',
    avg: 0,
    winsPercentage : 0,
    touch : 0,
    perfect : 0,
    chefmet : 0,
}

export const WinlosesReducer : Reducer<MusicWinlosesState, MusicWinlosesDispatchAction>= 
    (state = initialState, action) => {
        switch(action.type) {
            case WinlosesTypes.FETCH_START:
                return state
            case WinlosesTypes.FETCH_SUCCESS:
                return action.payload
            default:
                return state
        }
    }

export default WinlosesReducer;